import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "./apiClient";
import type { TestHttpLog } from "@/pages/testing/shared";

/**
 * Test OTP / heslo — admin API `/admin/api/v1/testing/otp-password/**`. `/start`
 * streamuje SSE (viz [[sse.ts]]). Tři režimy: OTP_GENERATION (lokální),
 * PASSWORD_CHANGE (lokální), OTP_VERIFY (auth server).
 */

export type OtpTestMode = "OTP_GENERATION" | "PASSWORD_CHANGE" | "OTP_VERIFY";

export const OTP_TEST_MODES: OtpTestMode[] = ["OTP_GENERATION", "PASSWORD_CHANGE", "OTP_VERIFY"];

export interface OtpPasswordRequest {
  tokenId: string;
  testMode: OtpTestMode;
  currentPassword?: string | null;
  newPassword?: string | null;
  otpCode?: string | null;
}

export interface OtpPasswordResult {
  success: boolean;
  tokenId: string;
  testMode: OtpTestMode;
  generatedOtp?: string | null;
  generatedOtpExpiresAt?: string | null;
  passwordChanged?: boolean | null;
  otpValid?: boolean | null;
  completedAt: string;
  durationMs: number;
  httpLogs: TestHttpLog[];
}

export interface OtpPasswordProgress {
  status: string;
  message: string;
  timestamp: string;
  data?: OtpPasswordResult;
}

/** Předvyplněné scénáře odvozené z aktivních tokenů (username + password). */
export interface OtpPasswordScenario {
  name: string;
  description: string;
  tokenId: string;
  authServerType: string;
  username: string;
  testMode: OtpTestMode;
  currentPassword?: string | null;
  newPassword?: string | null;
  existingOtp?: string | null;
}

export function useOtpPasswordScenarios() {
  return useQuery({
    queryKey: ["test-otp-password", "scenarios"],
    queryFn: () => apiFetch<OtpPasswordScenario[]>("/admin/api/v1/testing/otp-password/scenarios"),
  });
}
